import { useState } from "react";

const ACCENT = "#00e5b0";
const BG = "#080d17";
const CARD = "#0e1525";
const TEXT = "#edf2ff";
const TEXT2 = "#8fa3c8";
const TEXT3 = "#4d6080";
const BORDER = "rgba(255,255,255,0.06)";

function FacebookIcon({ size = 24, color = "#8fa3c8" }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill={color}>
      <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"/>
    </svg>
  );
}

function InstagramIcon({ size = 24, color = "#8fa3c8" }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="2" y="2" width="20" height="20" rx="5" ry="5"/>
      <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"/>
      <line x1="17.5" y1="6.5" x2="17.51" y2="6.5"/>
    </svg>
  );
}

export default function Landing({ onLogin, onRegister }) {
  const [billingPeriod, setBillingPeriod] = useState("monthly");
  const [openFaq, setOpenFaq] = useState(null);

 const plans = [
    {
      name: "Free",
      price: { monthly: "P0", yearly: "P0" },
      description: "Get started with basic sports data tools",
      features: [
        "Multi-platform data comparison",
        "Basic statistical analysis",
        "3 platform data sources",
        "Daily data updates",
        "Community access",
      ],
      cta: "Get Started",
      highlight: false,
    },
    {
      name: "Edge",
      price: { monthly: "P99/mo", yearly: "P890/yr" },
      description: "Advanced analytics for serious sports analysts",
      features: [
        "Everything in Free",
        "Real-time data across 6 platforms",
        "Advanced statistical models",
        "AI-powered combination analysis",
        "Automated alerts via Telegram",
        "Market movement tracking",
        "Historical data access",
        "Priority support",
      ],
      cta: "Start Edge Plan",
      highlight: true,
    },
    {
      name: "Elite",
      price: { monthly: "P199/mo", yearly: "P1,790/yr" },
      description: "Professional-grade analytics suite",
      features: [
        "Everything in Edge",
        "Poisson statistical modeling",
        "Team performance analysis",
        "Portfolio optimization tools",
        "API access",
        "Custom alert configuration",
        "Dedicated support",
        "Early access to new features",
      ],
      cta: "Start Elite Plan",
      highlight: false,
    },
  ];

  const features = [
    {
      icon: "📊",
      title: "Real-Time Data Aggregation",
      desc: "Aggregate and compare sports data from 6 major platforms simultaneously with sub-second refresh rates.",
    },
    {
      icon: "🤖",
      title: "AI-Powered Analysis",
      desc: "Machine learning models analyse thousands of data points to identify statistical anomalies and opportunities.",
    },
    {
      icon: "📈",
      title: "Poisson Distribution Modeling",
      desc: "Professional-grade mathematical models calculate true statistical probabilities for sports events.",
    },
    {
      icon: "⚡",
      title: "Instant Alerts",
      desc: "Receive automated notifications via Telegram when our algorithms detect significant statistical deviations.",
    },
    {
      icon: "💰",
      title: "Portfolio Analytics",
      desc: "Apply Modern Portfolio Theory and Kelly Criterion to optimise your sports data analytics portfolio.",
    },
    {
      icon: "🎯",
      title: "Multi-Platform Data Comparison",
      desc: "Compare statistical data across Betway, Sunbet, PST Bets, Bet267, BBets and BetXplosion in one dashboard.",
    },
  ];

  return (
    <div style={{ background: BG, minHeight: "100vh", fontFamily: "'DM Sans', Arial, sans-serif", color: TEXT }}>

      {/* Nav */}
      <nav style={{ padding: "16px 24px", display: "flex", justifyContent: "space-between", alignItems: "center", borderBottom: `1px solid ${BORDER}`, position: "sticky", top: 0, background: BG, zIndex: 100 }}>
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
  <img src="/icon-192.png" alt="OddsEdgeBW" style={{ width: 32, height: 32, borderRadius: 8 }} />
  <span style={{ fontFamily: "'Syne', sans-serif", fontWeight: 800, fontSize: 20 }}>OddsEdge<span style={{ color: ACCENT }}>BW</span></span>
</div>
        <div style={{ display: "flex", gap: 16, alignItems: "center" }}>
          <a href="https://www.facebook.com/share/14gFHB47JT9/?mibextid=wwXIfr" target="_blank" rel="noopener noreferrer" style={{ color: TEXT3, display: "flex", alignItems: "center" }}>
            <FacebookIcon size={20} color={TEXT3} />
          </a>
          <a href="https://www.instagram.com/oddsedgebw" target="_blank" rel="noopener noreferrer" style={{ color: TEXT3, display: "flex", alignItems: "center" }}>
            <InstagramIcon size={20} color={TEXT3} />
          </a>
          <button onClick={onLogin} style={{ padding: "8px 20px", background: "transparent", border: `1px solid ${BORDER}`, borderRadius: 8, color: TEXT2, cursor: "pointer", fontSize: 14 }}>Sign In</button>
          <button onClick={onRegister} style={{ padding: "8px 20px", background: ACCENT, border: "none", borderRadius: 8, color: "#080d17", cursor: "pointer", fontSize: 14, fontWeight: 700 }}>Get Started</button>
        </div>
      </nav>

      {/* Hero */}
      <section style={{ maxWidth: 900, margin: "0 auto", padding: "80px 24px 60px", textAlign: "center" }}>
        <div style={{ display: "inline-block", background: "rgba(0,229,176,0.1)", border: `1px solid rgba(0,229,176,0.2)`, borderRadius: 20, padding: "6px 16px", fontSize: 12, color: ACCENT, marginBottom: 24, fontWeight: 600, letterSpacing: 1 }}>
          BOTSWANA'S SPORTS DATA ANALYTICS PLATFORM
        </div>
        <h1 style={{ fontSize: "clamp(32px, 5vw, 52px)", fontWeight: 800, fontFamily: "'Syne', sans-serif", margin: "0 0 20px", lineHeight: 1.15 }}>
          Professional Sports Data<br /><span style={{ color: ACCENT }}>Analytics for Botswana</span>
        </h1>
        <p style={{ fontSize: 18, color: TEXT2, maxWidth: 600, margin: "0 auto 40px", lineHeight: 1.7 }}>
          Real-time statistical analysis, multi-platform data aggregation, and AI-powered insights across all major Botswana sports platforms.
        </p>
        <div style={{ display: "flex", gap: 12, justifyContent: "center", flexWrap: "wrap" }}>
          <button onClick={onRegister} style={{ padding: "14px 32px", background: ACCENT, border: "none", borderRadius: 10, color: "#080d17", cursor: "pointer", fontSize: 16, fontWeight: 700 }}>Start Free →</button>
          <button onClick={onLogin} style={{ padding: "14px 32px", background: "transparent", border: `1px solid ${BORDER}`, borderRadius: 10, color: TEXT2, cursor: "pointer", fontSize: 16 }}>Sign In</button>
        </div>
      </section>

      {/* Stats */}
      <section style={{ maxWidth: 900, margin: "0 auto", padding: "0 24px 60px" }}>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: 16, background: CARD, borderRadius: 16, padding: "32px 24px", border: `1px solid ${BORDER}` }}>
          {[
            { value: "6", label: "Data Sources" },
            { value: "700+", label: "Events Daily" },
            { value: "Real-Time", label: "Data Updates" },
            { value: "AI", label: "Powered Analysis" },
          ].map(s => (
            <div key={s.label} style={{ textAlign: "center" }}>
              <div style={{ fontFamily: "'Syne', sans-serif", fontWeight: 800, fontSize: 28, color: ACCENT, marginBottom: 4 }}>{s.value}</div>
              <div style={{ fontSize: 13, color: TEXT3 }}>{s.label}</div>
            </div>
          ))}
        </div>
      </section>

      {/* About Us */}
      <section style={{ maxWidth: 900, margin: "0 auto", padding: "0 24px 80px" }} id="about">
        <h2 style={{ fontFamily: "'Syne', sans-serif", fontWeight: 700, fontSize: 32, textAlign: "center", marginBottom: 32 }}>About Us</h2>
        <div style={{ background: CARD, border: `1px solid ${BORDER}`, borderRadius: 16, padding: "40px 40px" }}>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 40 }}>
            <div>
              <h3 style={{ color: ACCENT, fontFamily: "'Syne', sans-serif", fontSize: 18, marginBottom: 16 }}>Who We Are</h3>
              <p style={{ color: TEXT2, fontSize: 15, lineHeight: 1.8, margin: 0 }}>
                OddsEdgeBW (Pty) Ltd is a Botswana-registered sports data analytics company founded in 2026. We are headquartered in Gaborone, Botswana, and are dedicated to providing data-driven sports intelligence tools to enthusiasts across the country.
              </p>
            </div>
            <div>
              <h3 style={{ color: ACCENT, fontFamily: "'Syne', sans-serif", fontSize: 18, marginBottom: 16 }}>Our Mission</h3>
              <p style={{ color: TEXT2, fontSize: 15, lineHeight: 1.8, margin: 0 }}>
                Our mission is to democratise access to professional-grade sports data analytics in Botswana. We aggregate publicly available sports data and apply advanced mathematical models and artificial intelligence to provide users with meaningful statistical insights.
              </p>
            </div>
          </div>
          <div style={{ marginTop: 32, padding: "20px 24px", background: "rgba(0,229,176,0.04)", borderRadius: 10, border: `1px solid rgba(0,229,176,0.1)` }}>
            <div style={{ fontSize: 13, color: TEXT3, marginBottom: 4, textTransform: "uppercase", letterSpacing: 1 }}>Registered Address</div>
            <div style={{ color: TEXT2, fontSize: 15 }}>📍 Plot 55181, Phakalane, Gaborone, Botswana</div>
            <div style={{ color: TEXT2, fontSize: 15, marginTop: 4 }}>✉️ support@oddsedgebw.co.bw</div>
          </div>
        </div>
      </section>

      {/* Features */}
      <section style={{ maxWidth: 900, margin: "0 auto", padding: "0 24px 80px" }}>
        <h2 style={{ fontFamily: "'Syne', sans-serif", fontWeight: 700, fontSize: 32, textAlign: "center", marginBottom: 48 }}>Professional Analytics Tools</h2>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))", gap: 20 }}>
          {features.map(f => (
            <div key={f.title} style={{ background: CARD, border: `1px solid ${BORDER}`, borderRadius: 12, padding: "24px 20px" }}>
              <div style={{ fontSize: 32, marginBottom: 12 }}>{f.icon}</div>
              <div style={{ fontWeight: 700, fontSize: 15, marginBottom: 8 }}>{f.title}</div>
              <div style={{ fontSize: 13, color: TEXT2, lineHeight: 1.6 }}>{f.desc}</div>
            </div>
          ))}
        </div>
      </section>

      {/* Pricing */}
      <section style={{ maxWidth: 900, margin: "0 auto", padding: "0 24px 80px" }} id="pricing">
        <h2 style={{ fontFamily: "'Syne', sans-serif", fontWeight: 700, fontSize: 32, textAlign: "center", marginBottom: 16 }}>Simple, Transparent Pricing</h2>
        <p style={{ textAlign: "center", color: TEXT2, marginBottom: 32 }}>Choose the plan that fits your analytics needs</p>
        <div style={{ display: "flex", justifyContent: "center", marginBottom: 40 }}>
          <div style={{ display: "flex", background: CARD, borderRadius: 10, padding: 4, border: `1px solid ${BORDER}` }}>
            <button onClick={() => setBillingPeriod("monthly")} style={{ padding: "8px 20px", borderRadius: 8, border: "none", cursor: "pointer", fontSize: 14, fontWeight: 600, background: billingPeriod === "monthly" ? ACCENT : "transparent", color: billingPeriod === "monthly" ? "#080d17" : TEXT2 }}>Monthly</button>
            <button onClick={() => setBillingPeriod("yearly")} style={{ padding: "8px 20px", borderRadius: 8, border: "none", cursor: "pointer", fontSize: 14, fontWeight: 600, background: billingPeriod === "yearly" ? ACCENT : "transparent", color: billingPeriod === "yearly" ? "#080d17" : TEXT2 }}>
              Yearly <span style={{ fontSize: 11, color: billingPeriod === "yearly" ? "#080d17" : ACCENT }}>Save 25%</span>
            </button>
          </div>
        </div>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))", gap: 20 }}>
          {plans.map(plan => (
            <div key={plan.name} style={{ background: plan.highlight ? `rgba(0,229,176,0.04)` : CARD, border: `1px solid ${plan.highlight ? "rgba(0,229,176,0.3)" : BORDER}`, borderRadius: 16, padding: "32px 24px", position: "relative" }}>
              {plan.highlight && (
                <div style={{ position: "absolute", top: -12, left: "50%", transform: "translateX(-50%)", background: ACCENT, color: "#080d17", fontSize: 11, fontWeight: 700, padding: "4px 16px", borderRadius: 20, whiteSpace: "nowrap" }}>MOST POPULAR</div>
              )}
              <div style={{ fontFamily: "'Syne', sans-serif", fontWeight: 700, fontSize: 20, marginBottom: 4 }}>{plan.name}</div>
              <div style={{ fontSize: 13, color: TEXT2, marginBottom: 20 }}>{plan.description}</div>
              <div style={{ fontFamily: "'Syne', sans-serif", fontWeight: 800, fontSize: 32, color: ACCENT, marginBottom: 24 }}>{plan.price[billingPeriod]}</div>
              <ul style={{ listStyle: "none", padding: 0, margin: "0 0 32px", display: "flex", flexDirection: "column", gap: 10 }}>
                {plan.features.map(f => (
                  <li key={f} style={{ fontSize: 13, color: TEXT2, display: "flex", alignItems: "flex-start", gap: 8 }}>
                    <span style={{ color: ACCENT, flexShrink: 0 }}>✓</span> {f}
                  </li>
                ))}
              </ul>
              <button onClick={onRegister} style={{ width: "100%", padding: "12px", background: plan.highlight ? ACCENT : "transparent", border: `1px solid ${plan.highlight ? ACCENT : BORDER}`, borderRadius: 10, color: plan.highlight ? "#080d17" : TEXT2, cursor: "pointer", fontSize: 14, fontWeight: 700 }}>{plan.cta}</button>
            </div>
          ))}
        </div>
      </section>

      {/* Cancellation & Refund Policy */}
      <section style={{ maxWidth: 900, margin: "0 auto", padding: "0 24px 80px" }} id="policy">
        <h2 style={{ fontFamily: "'Syne', sans-serif", fontWeight: 700, fontSize: 32, textAlign: "center", marginBottom: 32 }}>Cancellation & Refund Policy</h2>
        <div style={{ background: CARD, border: `1px solid ${BORDER}`, borderRadius: 16, padding: "40px" }}>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 32 }}>
            <div>
              <h3 style={{ color: ACCENT, fontFamily: "'Syne', sans-serif", fontSize: 18, marginBottom: 16 }}>Cancellation Policy</h3>
              <ul style={{ listStyle: "none", padding: 0, margin: 0, display: "flex", flexDirection: "column", gap: 12 }}>
                {[
                  "Subscriptions can be cancelled at any time",
                  "Cancellation takes effect at the end of the current billing period",
                  "No cancellation fees or penalties apply",
                  "Access continues until the end of the paid period",
                  "You can resubscribe at any time after cancellation",
                ].map(item => (
                  <li key={item} style={{ fontSize: 14, color: TEXT2, display: "flex", gap: 8 }}>
                    <span style={{ color: ACCENT, flexShrink: 0 }}>✓</span> {item}
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <h3 style={{ color: ACCENT, fontFamily: "'Syne', sans-serif", fontSize: 18, marginBottom: 16 }}>Refund Policy</h3>
              <ul style={{ listStyle: "none", padding: 0, margin: 0, display: "flex", flexDirection: "column", gap: 12 }}>
                {[
                  "No refunds are issued for the current billing period",
                  "Annual subscriptions are non-refundable after 7 days",
                  "Refunds may be considered in exceptional circumstances",
                  "Contact support@oddsedgebw.co.bw for refund requests",
                  "Disputes will be resolved within 5 business days",
                ].map(item => (
                  <li key={item} style={{ fontSize: 14, color: TEXT2, display: "flex", gap: 8 }}>
                    <span style={{ color: "#f04747", flexShrink: 0 }}>✕</span> {item}
                  </li>
                ))}
              </ul>
            </div>
          </div>
          <div style={{ marginTop: 32, padding: "16px 20px", background: "rgba(0,229,176,0.04)", borderRadius: 10, border: `1px solid rgba(0,229,176,0.1)`, fontSize: 13, color: TEXT3, lineHeight: 1.7 }}>
            To cancel your subscription or request a refund, please contact us at <span style={{ color: ACCENT }}>support@oddsedgebw.co.bw</span>. Our support team will respond within 1-2 business days.
          </div>
        </div>
      </section>

      {/* CTA */}
      <section style={{ maxWidth: 900, margin: "0 auto", padding: "0 24px 80px" }}>
        <div style={{ background: `rgba(0,229,176,0.04)`, border: `1px solid rgba(0,229,176,0.2)`, borderRadius: 20, padding: "60px 40px", textAlign: "center" }}>
          <h2 style={{ fontFamily: "'Syne', sans-serif", fontWeight: 700, fontSize: 32, marginBottom: 16 }}>Start Analysing Today</h2>
          <p style={{ color: TEXT2, fontSize: 16, marginBottom: 32, maxWidth: 500, margin: "0 auto 32px" }}>
            Join Botswana's most advanced sports data analytics platform. Free to start, no credit card required.
          </p>
          <button onClick={onRegister} style={{ padding: "14px 40px", background: ACCENT, border: "none", borderRadius: 10, color: "#080d17", cursor: "pointer", fontSize: 16, fontWeight: 700 }}>Get Started Free →</button>
        </div>
      </section>

      {/* Footer */}
      <footer style={{ borderTop: `1px solid ${BORDER}`, padding: "48px 24px 32px" }}>
        <div style={{ maxWidth: 900, margin: "0 auto" }}>
          <div style={{ display: "grid", gridTemplateColumns: "2fr 1fr 1fr", gap: 40, marginBottom: 40 }}>
            <div>
              <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 12 }}>
  <img src="/icon-192.png" alt="OddsEdgeBW" style={{ width: 28, height: 28, borderRadius: 6 }} />
  <span style={{ fontFamily: "'Syne', sans-serif", fontWeight: 800, fontSize: 20 }}>OddsEdge<span style={{ color: ACCENT }}>BW</span></span>
</div>
              <p style={{ color: TEXT3, fontSize: 13, lineHeight: 1.7, margin: "0 0 16px" }}>
                Botswana's sports data analytics platform providing real-time statistical analysis and AI-powered insights.
              </p>
              <div style={{ display: "flex", gap: 12 }}>
                <a href="https://www.facebook.com/share/14gFHB47JT9/?mibextid=wwXIfr" target="_blank" rel="noopener noreferrer" style={{ width: 36, height: 36, background: CARD, border: `1px solid ${BORDER}`, borderRadius: 8, display: "flex", alignItems: "center", justifyContent: "center" }}>
                  <FacebookIcon size={18} color={TEXT2} />
                </a>
                <a href="https://www.instagram.com/oddsedgebw" target="_blank" rel="noopener noreferrer" style={{ width: 36, height: 36, background: CARD, border: `1px solid ${BORDER}`, borderRadius: 8, display: "flex", alignItems: "center", justifyContent: "center" }}>
                  <InstagramIcon size={18} color={TEXT2} />
                </a>
              </div>
            </div>
            <div>
              <div style={{ fontWeight: 600, fontSize: 13, marginBottom: 16, color: TEXT }}>Platform</div>
              {["Features", "Pricing", "About Us", "Contact"].map(item => (
                <div key={item} style={{ fontSize: 13, color: TEXT3, marginBottom: 10 }}>{item}</div>
              ))}
            </div>
            <div>
              <div style={{ fontWeight: 600, fontSize: 13, marginBottom: 16, color: TEXT }}>Contact</div>
              <div style={{ fontSize: 13, color: TEXT3, marginBottom: 8 }}>support@oddsedgebw.co.bw</div>
              <div style={{ fontSize: 13, color: TEXT3, marginBottom: 8 }}>Plot 55181, Phakalane</div>
              <div style={{ fontSize: 13, color: TEXT3, marginBottom: 8 }}>Gaborone, Botswana</div>
            </div>
          </div>
          <div style={{ borderTop: `1px solid ${BORDER}`, paddingTop: 24, display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: 12 }}>
            <p style={{ color: TEXT3, fontSize: 12, margin: 0 }}>© 2026 OddsEdgeBW (Pty) Ltd · All rights reserved</p>
            <p style={{ color: TEXT3, fontSize: 12, margin: 0 }}>OddsEdgeBW provides sports data analytics tools for informational purposes only.</p>
          </div>
          <a href="/cancellation-policy.html" style={{ color: TEXT3 }}>Cancellation Policy</a>
<a href="/refund-policy.html" style={{ color: TEXT3 }}>Refund Policy</a>
        </div>
      </footer>
    </div>
  );
}